import _ from 'lodash'
import { format } from 'date-fns'

import { getCustomIntl, getGlobalParams } from 'config/config'
import { getSpecificAttrValue, checkIsYoungFund } from '../../../../utils'

const redIsRaise = true
const tcLanguageTag = 'zh-TW'
const enLanguageTag = 'en-001'
const intl = getCustomIntl()
const { countryConfig } = getGlobalParams()

const rule = {
  generalInfo: {
    shareClassId: '${scId}',
    shareClassEnglishName: (data) => getSpecificAttrValue({ originData: data.shareclassName, attrValue: enLanguageTag }),
    shareClassNameZh: (data) => getSpecificAttrValue({ originData: data.shareclassName, attrValue: tcLanguageTag }),
    fundName: (data) => {
      const fundNameZh = getSpecificAttrValue({ originData: data.fundName, attrValue: tcLanguageTag })
      const fundOriginalName = getSpecificAttrValue({ originData: data.fundOriginalName, attrValue: tcLanguageTag, valuePlaceholder: '' })

      return `${fundNameZh}${fundOriginalName ? `(${fundOriginalName})` : ''}`
    },
    isin: (data) => getSpecificAttrValue({ originData: data.isin }),
    followingDisclaimer: (data) => {
      return data.shareclassNote ? getSpecificAttrValue({ originData: data.shareclassNote, attrValue: tcLanguageTag }) : ''
    },
    englishName: (data) => getSpecificAttrValue({ originData: data.fundName, attrValue: enLanguageTag }),
    redIsRaise,
    navPriceDate: (data) => getSpecificAttrValue({ originData: data.price, dataPath: 'nav.priceDate', valuePlaceholder: '' }),
    launchDate: '${shareClassLaunchDate}',
    isYoungFund: (data) => {
      return countryConfig.specialTreatmentISINsOfYoungFund.includes(data.isin) ? false : checkIsYoungFund(data.shareClassLaunchDate)
    },
    performanceStartDate: '${performanceStartDate}',
    riskMorningStarInfo: {
      riskLevel: (data) => data.fundRating || '-',
      morningStarCount: (data) => (data.msRating ? data.msRating : intl.formatMessage({ id: 'nonRiskRating' })),
      morningStarSize: '20'
    },
    netValueInfo: {
      currency: (data) => getSpecificAttrValue({ originData: data.baseCurrency, attrValue: tcLanguageTag, dataPath: 'data' }),
      currencyCode: (data) => getSpecificAttrValue({ originData: data.baseCurrency.currencyCode }),
      currentValue: (data) => getSpecificAttrValue({ originData: data.price, dataPath: 'nav.nav' }),
      changeValue: (data) => getSpecificAttrValue({ originData: data.price, dataPath: 'changeAbsolute' }),
      changePercent: (data) => getSpecificAttrValue({ originData: data.price, dataPath: 'changePercent' })
    },
    incomeTypeCode: (data) => getSpecificAttrValue({ originData: data.incomeType.incomeTypeCode }),
    assetClassId: (data) => getSpecificAttrValue({ originData: data.assetClass.assetClassId }),
    isOnshoreFund: (data) => data.fundRange && data.fundRange.rangeCode === 'TW-ONSHORE',
    taCode: '${taCode}',
    msRatingDate: (data) => (data.msRatingDate ? format(new Date(data.msRatingDate), 'yyyy-MM-dd') : ''),
    monthlyReportLink: (data) =>
      getSpecificAttrValue({
        originData: data.documentWithType,
        dataPath: 'data',
        attrValue: 'zh-TW',
        targetAttr: 'url',
        valuePlaceholder: ''
      }),
    investmentGoalContent: (data) =>
      getSpecificAttrValue({
        originData: data.investmentObjective,
        attrValue: tcLanguageTag,
        targetAttr: 'description'
      }),
    isSoftClose: (data) => data.isSoftClose === 'Y',
    fundType: (data) =>
      getSpecificAttrValue({
        originData: data.assetClass,
        dataPath: 'data',
        attrValue: tcLanguageTag,
        targetAttr: 'name',
        valuePlaceholder: ''
      }),
    investmentRegion: (data) =>
      getSpecificAttrValue({
        originData: data.investmentRegion,
        dataPath: 'data',
        attrValue: tcLanguageTag,
        targetAttr: 'name',
        valuePlaceholder: ''
      }),
    headFundName: (data) =>
      getSpecificAttrValue({
        originData: data.fundName,
        attrValue: tcLanguageTag,
        valuePlaceholder: ''
      }),
    displayName: (data) => getSpecificAttrValue({ originData: data.shareclassName, attrValue: tcLanguageTag, valuePlaceholder: '' }),
    newLaunchWarningMsg: (data) => {
      if (countryConfig.tempNewLanuchISINs.includes(data.isin)) {
        return intl.formatMessage({ id: `fundDetail.tempNewLanuchWarningMsg.${data.isin}` })
      }

      return ''
    },
    pastPerformanceDisclaimer: (data) => {
      const pastPerformanceDisclaimer = getSpecificAttrValue({
        originData: data.disclaimer,
        dataPath: 'pastPerformanceDisclaimer.description',
        attrValue: tcLanguageTag,
        valuePlaceholder: ''
      })
      return pastPerformanceDisclaimer
    }
  }
}

export default rule
